import { incYenOf } from '../../../lib/pricing';

const butlerTrainingSchool = {
  // HeroSection
  'butlerTrainingSchool.hero.homeLink': 'ホーム',
  'butlerTrainingSchool.hero.currentPage': '執事養成学校とは？',
  'butlerTrainingSchool.hero.title': '執事養成学校とは？',
  'butlerTrainingSchool.hero.titleEn': 'WHAT IS A BUTLER TRAINING SCHOOL',
  'butlerTrainingSchool.hero.lead':
    '執事養成学校とは、執事という職業に必要な技能を体系的に訓練し、現場に立てる状態まで仕上げる場所です。日本執事アカデミーは、東京・お台場に実際に通える本校を構える、日本で唯一の学び舎を持つ執事養成学校です。このページでは、これから学ぶ方が進路として検討するために必要な実務的な視点——訓練される内容、期間と費用、学び方の形式、学び舎の選び方——を順に整理します。',
  'butlerTrainingSchool.hero.imgAlt': '屋外の校舎中庭で、黒モーニングコートに白手袋の男性執事が身をかがめ手のひらを差し出して来訪者を迎え入れ、右にグレーのジャケットの若い男性が立ち、背景に濃い灰色の煉瓦壁とカラフルなバルコニー、奥に緑と木製のベンチがある明るい昼の構図',

  // TrainingMeaning
  'butlerTrainingSchool.meaning.label': 'DEFINITION',
  'butlerTrainingSchool.meaning.title': '「学ぶ」ことと「養成される」ことの違い',
  'butlerTrainingSchool.meaning.titleEn': 'Learning and Being Trained',
  'butlerTrainingSchool.meaning.para1':
    '執事学校という言葉には、知識を教わる場所という響きがあります。一方で執事養成学校が引き受けているのは、知識の伝達だけではありません。職業人として現場に立てるところまで、身体の使い方ごと作り替える訓練です。両者の差は、修了した時点で「知っている」で止まっているか、「その場でできる」に届いているかにあらわれます。',
  'butlerTrainingSchool.meaning.para2':
    '執事養成の現場では、たとえばトレーの持ち方ひとつを、頭で理解したあとに何十回と反復します。角度・歩幅・視線の高さを講師がその場で修正し、意識しなくても同じ所作が出るところまで固めていきます。教養として執事の世界に触れたい方と、職業として身を立てたい方とでは、必要な訓練の密度が違います。執事養成学校を進路として検討するときは、まずこの前提をご確認ください。',
  'butlerTrainingSchool.meaning.imgAlt': '頭上に本を載せて姿勢を保つ基本訓練に取り組む受講生',
  'butlerTrainingSchool.meaning.imgCaption': '姿勢は知識ではなく、反復によって身につける',
  'butlerTrainingSchool.meaning.0.title': '知識の習得はゴールではない',
  'butlerTrainingSchool.meaning.0.desc':
    '講義で理解した内容は、実技とロールプレイングで再現できて初めて技能になります。理解と再現のあいだには、反復訓練という工程が必ず入ります。',
  'butlerTrainingSchool.meaning.1.title': '到達を測る基準がある',
  'butlerTrainingSchool.meaning.1.desc':
    '職業訓練である以上、到達したかどうかを測る基準が必要です。日本執事アカデミーでは修了要件として出席率80%以上を定め、各コースの修了時に筆記試験（30分）と実技試験を実施しています。',
  'butlerTrainingSchool.meaning.2.title': '修了後に残るものが違う',
  'butlerTrainingSchool.meaning.2.desc':
    '知識は時間とともに薄れますが、身体に入った所作は残ります。加えて合格者には一般社団法人全日本執事協会の認定資格が授与され、学んだ事実を第三者に示せる形になります。',

  // FourDomains
  'butlerTrainingSchool.domains.label': 'FOUR DOMAINS',
  'butlerTrainingSchool.domains.title': '執事養成学校で訓練される技能の4系統',
  'butlerTrainingSchool.domains.titleEn': 'Four Domains of Training',
  'butlerTrainingSchool.domains.lead':
    '扱う技能は多岐にわたりますが、整理すると4つの系統に分けられます。どの系統も座学だけでは完結せず、実技とロールプレイングを伴います。',
  'butlerTrainingSchool.domains.0.title': '所作と給仕',
  'butlerTrainingSchool.domains.0.desc':
    'ティーサービス、テーブルセッティング、トレーの扱い、立ち居振る舞い。ゲストの前に立つときに直接見られる技能です。歩幅や視線の配り方まで含めて、迷いのない型として固めます。',
  'butlerTrainingSchool.domains.0.imgAlt': 'サロンでトレーを手に歩行し、給仕の所作を確かめる執事',
  'butlerTrainingSchool.domains.1.title': '邸宅運営と管理',
  'butlerTrainingSchool.domains.1.desc':
    '食器・銀器・衣類・備品の管理、記録の付け方、外部との調整といった、表に見えない実務です。何がどこにいくつあるかを把握し続ける力が、当日のサービスの質を決めます。',
  'butlerTrainingSchool.domains.1.imgAlt': '食器棚のなかでカップとソーサーの並びを整える執事',
  'butlerTrainingSchool.domains.2.title': '来客応対と守秘',
  'butlerTrainingSchool.domains.2.desc':
    'お出迎えからお見送りまでの応対、言葉遣い、距離感の取り方に加え、知り得た情報を外に出さない職業倫理を訓練します。守秘は技能というより規律ですが、繰り返し確認しなければ身につきません。',
  'butlerTrainingSchool.domains.2.imgAlt': '白木のルーバー壁と障子風の窓がある明るい和モダンの待合で、黒モーニングコートに白手袋の男性執事が手を前に組んで一礼し、カウンター越しに白ブラウスの女性スタッフ2名も同じく一礼している',
  'butlerTrainingSchool.domains.3.title': '緊急時の判断',
  'butlerTrainingSchool.domains.3.desc':
    '予定の変更、体調不良、想定外の来客。手順書のない場面で、何を優先し誰に伝えるかを決める力です。ロールプレイングで多くの場面を経験し、迷う時間を短くしていきます。',
  'butlerTrainingSchool.domains.3.imgAlt': '書斎の机で懐中時計を確認しながら手帳に記録する執事',
  'butlerTrainingSchool.domains.note':
    'この4系統は科目として切り分けるのではなく、実習のなかで同時に扱います。学ぶ内容の全体像はカリキュラムのページでご確認いただけます。',
  'butlerTrainingSchool.domains.noteLink': 'カリキュラムを見る',

  // TimeAndCost
  'butlerTrainingSchool.cost.label': 'TIME & COST',
  'butlerTrainingSchool.cost.title': '学ぶ期間と費用をどう考えるか',
  'butlerTrainingSchool.cost.titleEn': 'Time and Cost',
  'butlerTrainingSchool.cost.lead':
    '執事養成学校を検討するとき、期間と費用は総額だけでなく「何時間の訓練に対していくらか」で見ると、生活への組み込み方まで判断しやすくなります。日本執事アカデミーの3コースを例に、期間・通学日数・総訓練時間・受講料を並べます。',
  'butlerTrainingSchool.cost.col.course': 'コース',
  'butlerTrainingSchool.cost.col.duration': '期間',
  'butlerTrainingSchool.cost.col.days': '通学日数',
  'butlerTrainingSchool.cost.col.hours': '総訓練時間',
  'butlerTrainingSchool.cost.col.price': '受講料（税込）',
  'butlerTrainingSchool.cost.row0.course': 'エッセンシャル',
  'butlerTrainingSchool.cost.row0.duration': '1ヶ月',
  'butlerTrainingSchool.cost.row0.days': '8日間',
  'butlerTrainingSchool.cost.row0.hours': '48時間',
  'butlerTrainingSchool.cost.row0.price': `${incYenOf('ac-essential')}円`,
  'butlerTrainingSchool.cost.row1.course': 'アドバンス',
  'butlerTrainingSchool.cost.row1.duration': '2ヶ月',
  'butlerTrainingSchool.cost.row1.days': '12日間',
  'butlerTrainingSchool.cost.row1.hours': '72時間',
  'butlerTrainingSchool.cost.row1.price': `${incYenOf('ac-advanced')}円`,
  'butlerTrainingSchool.cost.row2.course': 'マスター',
  'butlerTrainingSchool.cost.row2.duration': '3ヶ月',
  'butlerTrainingSchool.cost.row2.days': '16日間',
  'butlerTrainingSchool.cost.row2.hours': '96時間',
  'butlerTrainingSchool.cost.row2.price': `${incYenOf('ac-master')}円`,
  'butlerTrainingSchool.cost.note0.title': '時間の入れ方から逆算する',
  'butlerTrainingSchool.cost.note0.desc':
    '授業はすべて土日に開催し、1日6時間（90分×4コマ）です。通学日数と総訓練時間がわかれば、執事養成にかける時間を生活のどこに差し込めるかを先に逆算できます。',
  'butlerTrainingSchool.cost.note1.title': '支払い方法を先に確認する',
  'butlerTrainingSchool.cost.note1.desc':
    'お支払いは銀行振込による一括払いのみで、分割払い・クレジットカードはご利用いただけません。段階的に上位コースへ進む方には編入優遇制度があり、減額の内容は料金詳細のページに掲載しています。',
  'butlerTrainingSchool.cost.note2.title': '判断がつかないときの入口',
  'butlerTrainingSchool.cost.note2.desc': `本科を決めかねる場合は、1日6時間の体験講座（${incYenOf('ac-trial')}円・税込）があります。ご参加から1年以内に本科へお申込みの場合、参加費は受講料へ全額充当されます。`,
  'butlerTrainingSchool.cost.priceLink': '料金詳細を見る',
  'butlerTrainingSchool.cost.imgAlt': '金彩の皿・白手袋・懐中時計・教本を並べた俯瞰の静物',

  // StudyFormats
  'butlerTrainingSchool.formats.label': 'STUDY FORMATS',
  'butlerTrainingSchool.formats.title': '通学・オンデマンド・短期講座の違い',
  'butlerTrainingSchool.formats.titleEn': 'Formats of Study',
  'butlerTrainingSchool.formats.lead':
    '執事養成学校の学び方は、通学（対面）、オンデマンド（動画）、短期の体験講座に大別できます。それぞれ得意なことが違うため、目的に応じて組み合わせるのが現実的です。',
  'butlerTrainingSchool.formats.0.title': '通学（対面）',
  'butlerTrainingSchool.formats.0.desc':
    '実技とロールプレイングは対面でしか成立しません。講師が所作を見て、その場で角度や重心を直す——この往復がある形式です。執事学校を選ぶときに実技の比率を確かめるべき理由も、ここにあります。',
  'butlerTrainingSchool.formats.1.title': 'オンデマンド（動画）',
  'butlerTrainingSchool.formats.1.desc':
    '知識の予習・復習に向いた形式です。日本執事アカデミーでは、対面授業に予習・復習用のオンデマンド動画講座を組み合わせたハイブリッド形式を採用し、対面の時間を実技とロールプレイングに充てています。',
  'butlerTrainingSchool.formats.2.title': '短期の体験講座',
  'butlerTrainingSchool.formats.2.desc':
    '本科に進むかどうかを判断するための形式です。1日6時間で、講師・教室・授業の進み方を実際に確かめられます。学び舎の雰囲気を自分の目で見てから決めたい方に向いています。',
  'butlerTrainingSchool.formats.working.title': '働きながら学べるかを見分ける3点',
  'butlerTrainingSchool.formats.working.desc':
    '授業がすべて土日開催で1日6時間であること、知識面をオンデマンド動画で補えることから、平日にお勤めの方でも計画的に通学いただけます。ご検討中の学び舎については「授業が何曜日か」「1日あたり何時間か」「復習を補える手段があるか」の3点を確かめると、続けられるかどうかを事前に判断できます。',
  'butlerTrainingSchool.formats.imgAlt': 'サロンで教本を手に講義する講師と、着席して受講する2名の受講生',

  // ChoosingChecklist
  'butlerTrainingSchool.checklist.label': 'HOW TO CHOOSE',
  'butlerTrainingSchool.checklist.title': '執事養成学校の選び方チェックリスト',
  'butlerTrainingSchool.checklist.titleEn': 'A Checklist for Choosing',
  'butlerTrainingSchool.checklist.lead':
    '執事養成学校は数が限られており、比較のための情報も多くはありません。そこで、どこが優れているかではなく、ご自身で確かめられる観点として次の5点を挙げます。当校の場合の状況も併記しますので、検討の物差しとしてお使いください。',
  'butlerTrainingSchool.checklist.0.title': '実際に通える学び舎があるか',
  'butlerTrainingSchool.checklist.0.desc':
    '教室の所在地と、そこで対面の実技が行われているかを確認します。所作の訓練は、場所と道具があって初めて成立します。日本執事アカデミーの本校は東京都江東区青海（お台場）にあり、日本で唯一の学び舎を持つ執事養成学校として、対面の実技はこの校舎で行っています。',
  'butlerTrainingSchool.checklist.1.title': '定員と個別指導の密度',
  'butlerTrainingSchool.checklist.1.desc':
    '1クラス何名かは、講師から自分に向けられる時間の量をそのまま表します。当校は定員6名（最少催行3名）の完全少人数制で、講師が一人ひとりの所作を細部まで確認します。',
  'butlerTrainingSchool.checklist.2.title': '修了後に何が認定されるか',
  'butlerTrainingSchool.checklist.2.desc':
    '修了証のみなのか、認定資格が発行されるのか、それは誰が認定するのかを確認します。当校はコースに応じて認定アソシエイトバトラー・認定プロフェッショナルバトラー・認定マスターバトラーの3資格があり、いずれも一般社団法人全日本執事協会が独自に認定する民間資格です。',
  'butlerTrainingSchool.checklist.3.title': '運営母体は誰か',
  'butlerTrainingSchool.checklist.3.desc':
    '運営しているのが誰かは、カリキュラムと認定の裏付けにあたります。当校の運営母体は一般社団法人全日本執事協会です。',
  'butlerTrainingSchool.checklist.4.title': '実技の比率と教材の体系',
  'butlerTrainingSchool.checklist.4.desc':
    '総時間のうち実技がどれだけを占めるか、使用する教材が体系立っているかを見ます。当校では協会監修の専門教科書 全15冊（基礎・応用・専門の各5冊）を、コースに応じて使用します。',
  'butlerTrainingSchool.checklist.note':
    '※上記は他校との優劣を判定するための基準ではありません。ご自身の目的——教養として触れたいのか、職業として身を立てたいのか——に照らして、必要な条件が揃っているかを確かめるための観点です。',
  'butlerTrainingSchool.checklist.imgAlt': '食器棚の前で目録を手に記録を付ける執事',

  // CareerPaths
  'butlerTrainingSchool.career.label': 'AFTER COMPLETION',
  'butlerTrainingSchool.career.title': '修了後に開かれる進路の広がり',
  'butlerTrainingSchool.career.titleEn': 'Pathways After Completion',
  'butlerTrainingSchool.career.lead':
    '執事養成を経て身につく技能は、執事という職種だけに閉じたものではありません。人と接し、場を整え、先を読む仕事であれば応用の余地があります。修了後に考えられる方向を4つに整理しました。進路を描くときは役割の広がりに加え、海外では経験に応じた年収の目安が示されている点も、長期的な判断材料になります。',
  'butlerTrainingSchool.career.0.title': '個人邸・レジデンスでの職務',
  'butlerTrainingSchool.career.0.desc':
    '邸宅運営と管理、来客応対を一体で扱う場です。学んだ4系統をそのまま使う方向であり、少人数の体制で任される範囲が広くなります。2026年の英国の調査では、経験0〜2年の年収が£35,000〜£45,000、経験3〜7年で£50,000〜£70,000、経験8年以上で£75,000〜£120,000と、経験を重ねるほど年収のレンジが上がる構造が示されています。\n\nUHNW層を対象とした2026年のガイドでは£65,000〜£105,000、大規模邸宅のヘッドバトラーでは£95,000〜£150,000という水準も挙げられ、モナコや南仏では手取り月€6,000〜€9,500、スイスでは月CHF 7,500〜13,000といった地域差があり、米国の主邸クラスでは$110,000〜$190,000が目安とされます。住み込みの場合、ロンドンでは住居価値が年£15,000〜£25,000相当とされ、現金以外の条件も含めて比較する視点が求められます。',
  'butlerTrainingSchool.career.1.title': 'ホテル・上質なサービスの現場',
  'butlerTrainingSchool.career.1.desc':
    '所作と給仕、来客応対の比重が高い場です。チームで動く現場のため、決められた水準を安定して再現できることが評価につながります。ホテル職の年収について広く参照できる調査データは確認できていないため、金額をここで示すことはできません。',
  'butlerTrainingSchool.career.2.title': '現在の所属先で接遇水準を引き上げる',
  'butlerTrainingSchool.career.2.desc':
    '転職を前提にせず、いまのお仕事に持ち帰る方向です。先を読む観察力と距離感の取り方は、業種を問わず接客の質に直結します。訓練を積み、担える範囲を広げていくことはキャリアの土台になります。日本については執事の年収に関する公表された公的統計が確認できないため、国内の金額をここで示すことはできません。',
  'butlerTrainingSchool.career.3.title': 'さらに上位のコースへ進む',
  'butlerTrainingSchool.career.3.desc':
    '基礎を固めてから管理・危機対応・国際儀礼へ進む方向です。段階的に進む方には編入優遇制度があり、学びを積み上げやすくしています。海外の調査が示す経験と年収レンジの関係を踏まえると、上位コースで扱う管理・判断の訓練は、長期的に任される役割を広げる材料になり得ます。ただし、特定の学び舎で学べば収入が上がるといった因果を述べるものではありません。',
  'butlerTrainingSchool.career.note':
    '※当校は就職のあっせんや採用の保証を行うものではありません。修了が意味するのは技能の習得と認定資格の取得であり、その先の進路はご自身で選択いただくものです。年収の詳細な解説は、執事の仕事のページ（/butler-job）をご覧ください。',
  'butlerTrainingSchool.career.imgAlt': '鏡の前でネクタイを整え、身なりを確認する執事',

  // FAQ
  'butlerTrainingSchool.faq.label': 'FAQ',
  'butlerTrainingSchool.faq.title': 'よくあるご質問',
  'butlerTrainingSchool.faq.subtitleEn': 'Frequently Asked Questions',
  'butlerTrainingSchool.faq.footer': 'その他のご質問はお問い合わせフォームよりお寄せください',
  'butlerTrainingSchool.faq.q1': '執事養成学校と執事学校は何が違うのですか？',
  'butlerTrainingSchool.faq.a1':
    '呼び方の違いであり、指しているものは重なります。ただし「養成」という語には、知識を教えるだけでなく、職業人として現場に立てる状態まで訓練するという含みがあります。名称よりも、実技の比率・定員・修了時に何が認定されるかを確認して選ぶことをおすすめします。',
  'butlerTrainingSchool.faq.q2': '未経験ですが入学できますか。選考はありますか？',
  'butlerTrainingSchool.faq.a2':
    '18歳以上であればご応募いただけます（高校生はご応募いただけません）。国籍・性別・経験は問わず、入学選考はありません。定員6名に対し、先着順でお受けしています。',
  'butlerTrainingSchool.faq.q3': '執事養成学校に通うには、どのくらいの期間が必要ですか？',
  'butlerTrainingSchool.faq.a3':
    '基礎を固めるエッセンシャルは1ヶ月・8日間・48時間、ワインやイベント運営まで学ぶアドバンスは2ヶ月・12日間・72時間、管理と危機対応まで修めるマスターは3ヶ月・16日間・96時間です。授業は土日開催のため、通学期間中も平日のお仕事を続けていただけます。',
  'butlerTrainingSchool.faq.q4': '修了できるか不安です。試験に届かなかった場合はどうなりますか？',
  'butlerTrainingSchool.faq.a4':
    '修了には出席率80%以上が必要です。修了時の実技試験に不合格の場合も、1回まで無料で再試験を受けていただけます。執事養成は反復で仕上げる訓練であり、一度で届かないことを前提に再挑戦の機会を設けています。',
  'butlerTrainingSchool.faq.q5': '進路を決める前に、まず何から始めればよいですか？',
  'butlerTrainingSchool.faq.a5':
    '無料の個別相談（オンライン可）か、1日の体験講座からお試しください。体験講座は本科と同じ教室・同じ講師で行い、参加費はご参加から1年以内の本科お申込み時に受講料へ全額充当されます。',

  // CTA
  'butlerTrainingSchool.cta.label': 'TAKE THE NEXT STEP',
  'butlerTrainingSchool.cta.title': '進路としてご検討中の方へ',
  'butlerTrainingSchool.cta.body':
    '執事養成学校をご検討中で、どのコースが合うか判断がつかない場合は、個別相談（無料・オンライン可）をご利用ください。1日の体験講座で授業を確かめてからお決めいただくこともできます。',
  'butlerTrainingSchool.cta.note': '※ご相談はオンラインでも承ります',
  'butlerTrainingSchool.cta.courses': 'コースを見る',
  'butlerTrainingSchool.cta.seminar': '体験講座を見る',

  // RelatedPages
  'butlerTrainingSchool.related.title': '関連ページ',
  'butlerTrainingSchool.related.subtitleEn': 'Explore Further',
  'butlerTrainingSchool.related.viewLink': '詳しく見る',
  'butlerTrainingSchool.related.backLink': 'アカデミーについての総合ページへ戻る',
  'butlerTrainingSchool.related.link0.title': 'コース一覧・比較',
  'butlerTrainingSchool.related.link0.desc': '3つのコースの違いを一覧で確認',
  'butlerTrainingSchool.related.link1.title': 'カリキュラム概要',
  'butlerTrainingSchool.related.link1.desc': '学ぶ内容の全体像と進め方',
  'butlerTrainingSchool.related.link2.title': '体験講座',
  'butlerTrainingSchool.related.link2.desc': '1日で授業を確かめる入口',
  'butlerTrainingSchool.related.link3.title': 'コース別料金詳細',
  'butlerTrainingSchool.related.link3.desc': 'コースごとの料金内訳',
  'butlerTrainingSchool.related.link4.title': '応募資格・申込の流れ',
  'butlerTrainingSchool.related.link4.desc': '応募条件と受講確定までの手続き',
  'butlerTrainingSchool.related.link5.title': '修了証・認定資格について',
  'butlerTrainingSchool.related.link5.desc': '修了で得られる協会認定資格',

  // Last updated
  'butlerTrainingSchool.lastUpdated': '最終更新: 2026年7月25日',
};

export default butlerTrainingSchool;
